module.exports = __webpack_public_path__ + "img/l3.ab8f28a6.jpg";